import callable from './callable';
var createAnimationStyles = function (animation, theme) {
    var animationCSSProp = {};
    var _a = theme.animations, animations = _a === void 0 ? {} : _a;
    if (animation) {
        var animationName = typeof animation === 'string' ? animation : animation.name;
        if (animations[animationName]) {
            var _b = animations[animationName], keyframe = _b.keyframe, duration = _b.duration, delay = _b.delay, direction = _b.direction, fillMode = _b.fillMode, iterationCount = _b.iterationCount, playState = _b.playState, timingFunction = _b.timingFunction;
            var evaluatedKeyframe = typeof keyframe === 'string'
                ? keyframe
                : theme.renderer.renderKeyframe(callable(keyframe), {});
            if (typeof animation === 'string') {
                animationCSSProp = {
                    animationName: evaluatedKeyframe,
                    animationDelay: delay,
                    animationDirection: direction,
                    animationDuration: duration,
                    animationFillMode: fillMode,
                    animationIterationCount: iterationCount,
                    animationPlayState: playState,
                    animationTimingFunction: timingFunction,
                };
            }
            else {
                animationCSSProp = {
                    animationName: evaluatedKeyframe,
                    animationDelay: animation.delay || delay,
                    animationDirection: animation.direction || direction,
                    animationDuration: animation.duration || duration,
                    animationFillMode: animation.fillMode || fillMode,
                    animationIterationCount: animation.iterationCount || iterationCount,
                    animationPlayState: animation.playState || playState,
                    animationTimingFunction: animation.timingFunction || timingFunction,
                };
            }
        }
    }
    return animationCSSProp;
};
export default createAnimationStyles;
